export default {
  'en': require('./en.json'),
  'es': require('./es.json'),
  'fr': require('./fr.json')
}
